import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Gavel, FileSearch, Lock, Hash, Clock, Link as LinkIcon, ExternalLink, Briefcase, FileText } from 'lucide-react';
import { Button } from '../components/Button';
import { Badge } from '../components/Badge';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell } from '../components/Table';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../components/Dialog';
import { toast } from 'sonner';
import { RelatedWorkflow } from '../components/dashboard/RelatedWorkflow';
const cases = [{
  id: 'EVD-2026-0142',
  subject: 'Deepfake audio Presiden RI',
  platform: 'TikTok',
  url: 'tiktok.com/@u**/v/abc***',
  hash: 'sha256: a3f9...c812',
  collected: '14:32 WIB',
  size: '3 video, 2 audio',
  status: 'TERVERIFIKASI',
  custody: 5
}, {
  id: 'EVD-2026-0141',
  subject: 'Akun impersonation @presidenri_official',
  platform: 'X',
  url: 'x.com/presidenri_off***',
  hash: 'sha256: 88af...91e2',
  collected: '12:18 WIB',
  size: '1 profil, 24 cuitan',
  status: 'PROSES',
  custody: 3
}, {
  id: 'EVD-2026-0140',
  subject: 'Hoaks penarikan bansos pangan',
  platform: 'FB',
  url: 'facebook.com/p/12****',
  hash: 'sha256: 5b21...0f44',
  collected: '09:50 WIB',
  size: '1 post, 142 komentar',
  status: 'TERVERIFIKASI',
  custody: 4
}, {
  id: 'EVD-2026-0139',
  subject: 'Tagar #TolakKebijakanX terkoordinasi',
  platform: 'X',
  url: 'search.x.com/q=%23Tolak***',
  hash: 'sha256: 13ab...8e2c',
  collected: '03:12 WIB',
  size: '1.247 akun, 4.8K cuitan',
  status: 'PROSES',
  custody: 6
}, {
  id: 'EVD-2026-0138',
  subject: 'Doxxing aparat keamanan Papua',
  platform: 'Telegram',
  url: 'tg://chan/papua_***',
  hash: 'sha256: e09f...11a3',
  collected: 'Kemarin 22:01',
  size: '14 pesan, 3 dokumen',
  status: 'ESKALASI',
  custody: 7
}];
const statusColor: Record<string, string> = {
  TERVERIFIKASI: 'bg-emerald-500/10 text-emerald-500',
  PROSES: 'bg-amber-500/10 text-amber-500',
  ESKALASI: 'bg-red-500/10 text-red-500'
};
export function LegalEvidence() {
  const [open, setOpen] = useState<(typeof cases)[0] | null>(null);
  return <div className="mx-auto flex w-full max-w-[1600px] flex-col gap-6" data-id="element-2223">
      <PageHeader group="Hukum & Evidence" title="Legal Evidence Management" description="Manajemen bukti digital dengan chain-of-custody, hash kriptografi, dan timestamp tervalidasi." icon={Gavel} data-id="element-2224" />

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-2225">
        {[{
        label: 'Folder Kasus Aktif',
        value: '142',
        icon: FileSearch,
        color: 'text-blue-500'
      }, {
        label: 'Bukti Terverifikasi',
        value: '89',
        icon: Lock,
        color: 'text-emerald-500'
      }, {
        label: 'Menunggu Validasi',
        value: '34',
        icon: Clock,
        color: 'text-amber-500'
      }, {
        label: 'Total Storage',
        value: '4.2 TB',
        icon: Hash,
        color: 'text-purple-500'
      }].map(k => <Card key={k.label} className="bg-card border-border/50" data-id="element-2226">
            <CardContent className="p-4" data-id="element-2227">
              <div data-id="element-2228">
                <p className="font-mono text-[10px] uppercase text-muted-foreground" data-id="element-2229">
                  {k.label}
                </p>
                <p className={`font-heading text-2xl font-bold mt-1 ${k.color}`} data-id="element-2230">
                  {k.value}
                </p>
              </div>
              <k.icon className={`size-6 ${k.color}`} data-id="element-2231" />
            </CardContent>
          </Card>)}
      </div>

      <Card className="bg-card border-border/50" data-id="element-2232">
        <CardContent className="p-0" data-id="element-2233">
          <div className="overflow-x-auto" data-id="element-2234">
            <Table data-id="element-2235">
              <TableHeader className="bg-muted/20" data-id="element-2236">
                <TableRow className="border-border/50 hover:bg-transparent" data-id="element-2237">
                  <TableHead className="font-mono text-[9px]" data-id="element-2238">
                    ID BUKTI
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2239">SUBJEK</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2240">
                    PLATFORM
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2241">URL</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2242">HASH</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2243">
                    DIKUMPULKAN
                  </TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2244">CHAIN</TableHead>
                  <TableHead className="font-mono text-[9px]" data-id="element-2245">STATUS</TableHead>
                  <TableHead className="font-mono text-[9px] text-right" data-id="element-2246">
                    AKSI
                  </TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-2247">
                {cases.map(c => <TableRow key={c.id} className="border-border/30 hover:bg-muted/10" data-id="element-2248">
                    <TableCell className="font-mono text-xs" data-id="element-2249">{c.id}</TableCell>
                    <TableCell className="text-xs font-medium" data-id="element-2250">
                      {c.subject}
                    </TableCell>
                    <TableCell data-id="element-2251">
                      <span className="font-mono text-[10px] bg-muted px-1.5 py-0.5 rounded" data-id="element-2252">
                        {c.platform}
                      </span>
                    </TableCell>
                    <TableCell className="font-mono text-[10px] text-muted-foreground truncate max-w-[160px]" data-id="element-2253">
                      <LinkIcon className="size-3 inline mr-1" data-id="element-2254" />
                      {c.url}
                    </TableCell>
                    <TableCell className="font-mono text-[10px] text-muted-foreground" data-id="element-2255">
                      {c.hash}
                    </TableCell>
                    <TableCell className="font-mono text-[10px] text-muted-foreground" data-id="element-2256">
                      {c.collected}
                    </TableCell>
                    <TableCell className="font-mono text-xs" data-id="element-2257">
                      {c.custody}
                    </TableCell>
                    <TableCell data-id="element-2258">
                      <Badge variant="outline" className={`font-mono text-[8px] border-none ${statusColor[c.status]}`} data-id="element-2259">
                        {c.status}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right" data-id="element-2260">
                      <Button size="xs" variant="outline" className="h-6 text-[9px] font-mono" onClick={() => setOpen(c)} data-id="element-2261">
                        Lihat Paket
                      </Button>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>
        </CardContent>
      </Card>

      <Dialog open={!!open} onOpenChange={o => !o && setOpen(null)} data-id="element-2262">
        <DialogContent className="max-w-xl" data-id="element-2263">
          <DialogHeader data-id="element-2264">
            <DialogTitle data-id="element-2265">{open?.id}</DialogTitle>
            <DialogDescription data-id="element-2266">{open?.subject}</DialogDescription>
          </DialogHeader>
          {open && <div className="space-y-3" data-id="element-2267">
              <div className="grid grid-cols-2 gap-3 font-mono text-[11px]" data-id="element-2268">
                <div className="p-2 rounded bg-muted/20 border border-border/50" data-id="element-2269">
                  <p className="text-muted-foreground" data-id="element-2270">PLATFORM</p>
                  <p className="text-foreground" data-id="element-2271">{open.platform}</p>
                </div>
                <div className="p-2 rounded bg-muted/20 border border-border/50" data-id="element-2272">
                  <p className="text-muted-foreground" data-id="element-2273">CHAIN OF CUSTODY</p>
                  <p className="text-foreground" data-id="element-2274">{open.custody} log entry</p>
                </div>
                <div className="p-2 rounded bg-muted/20 border border-border/50 col-span-2" data-id="element-2275">
                  <p className="text-muted-foreground" data-id="element-2276">URL TARGET</p>
                  <p className="text-foreground break-all" data-id="element-2277">{open.url}</p>
                </div>
                <div className="p-2 rounded bg-muted/20 border border-border/50 col-span-2" data-id="element-2278">
                  <p className="text-muted-foreground" data-id="element-2279">HASH KRIPTOGRAFI</p>
                  <p className="text-foreground break-all" data-id="element-2280">{open.hash}</p>
                </div>
                <div className="p-2 rounded bg-muted/20 border border-border/50" data-id="element-2281">
                  <p className="text-muted-foreground" data-id="element-2282">DIKUMPULKAN</p>
                  <p className="text-foreground" data-id="element-2283">{open.collected}</p>
                </div>
                <div className="p-2 rounded bg-muted/20 border border-border/50" data-id="element-2284">
                  <p className="text-muted-foreground" data-id="element-2285">UKURAN</p>
                  <p className="text-foreground" data-id="element-2286">{open.size}</p>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-2287">
                <Button className="flex-1" onClick={() => {
              toast.success('Paket bukti diserahkan ke Aparat Penegak Hukum');
              setOpen(null);
            }} data-id="element-2288">
                  Serahkan ke Polri
                </Button>
                <Button variant="outline" onClick={() => toast.info('Mengunduh paket bukti...')} data-id="element-2289">
                  Unduh ZIP
                </Button>
              </div>
            </div>}
        </DialogContent>
      </Dialog>

      <RelatedWorkflow currentStep="Bukti Forensik" nextSteps={[{
      to: '/case-management',
      icon: FileSearch,
      label: 'Buka Berkas Kasus',
      desc: 'Hubungkan paket bukti ke berkas hukum aktif.'
    }, {
      to: '/platform-reporting',
      icon: ExternalLink,
      label: 'Lapor ke Platform',
      desc: 'Kirim takedown dengan bukti chain-of-custody.',
      badge: 'EKSTERNAL'
    }, {
      to: '/workbench',
      icon: Briefcase,
      label: 'Workbench Investigasi',
      desc: 'Analisis lintas-sumber untuk memperkuat bukti.'
    }, {
      to: '/reports',
      icon: FileText,
      label: 'Update Laporan',
      desc: 'Sertakan paket bukti di Crisis Alert Report.'
    }]} data-id="element-2290" />
    </div>;
}